import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
// dispatch(getAdminDetailsThunk());
const useAdminHelperFunction = (fieldKey) => {
  const [data, setData] = useState({});
  const {
    adminData,
  } = useSelector((state) => state.support);

  useEffect(() => {
    if(adminData && adminData.headerLinks && Object.keys(adminData.headerLinks).length !== 0){
      const arr = Object.entries(adminData.headerLinks)?.map((e) => ({ [e[0]]: e[1] }));
      const content = [];
      for (let i in arr) {
        content.push(...Object.values(arr[i]));
      }

      let arr1 = fieldKey;
      let updatedData = content.filter((i) => arr1.toLowerCase() == i.fieldKey.toLowerCase());
      if(updatedData.length){
        setData({
          ...updatedData[0],
          showField:
            updatedData[0]?.fieldVisible == "true"
              ? true
              : updatedData[0]?.fieldVisible == "false"
              ? false
              : updatedData[0]?.fieldVisible == "NA"
              ? updatedData[0]?.defaultFieldVisible == "true"
                ? true
                : false
              : true,
        });
      }    
    }
  }, []);
  // console.log(data, "admin hook");
  return data;
};

export default useAdminHelperFunction;
